/*
 --------------------------------------------------
 --------------------------------------------------
     Table Name : LU_EvaluationTimes
 --------------------------------------------------
 --------------------------------------------------
 DO NOT MODIFY MANUALLY
 --------------------------------------------------
 -------------------------------------------------- */

// Types
export type AfterSession = 'AfterSession';
export type AfterSessionEMR = 'AfterSessionEMR';
export type BeforeSession = 'BeforeSession';
export type BeforeSessionEMR = 'BeforeSessionEMR';
export type DuringSession = 'DuringSession';
export type EMR = 'EMR';
export type InRoomEvaluation = 'InRoomEvaluation';
export type LearnerExam = 'LearnerExam';
export type ManualScenario = 'ManualScenario';
export type Monitor = 'Monitor';
export type PatientExam = 'PatientExam';
export type PdlLive = 'PdlLive';
export type PdlPostSession = 'PdlPostSession';
export type PdlPreSession = 'PdlPreSession';
export type Reflection = 'Reflection';
export type ScoringRubric = 'ScoringRubric';
export type StandaloneAdminEval = 'StandaloneAdminEval';

export type EvaluationTime =
    | AfterSession
    | AfterSessionEMR
    | BeforeSession
    | BeforeSessionEMR
    | DuringSession
    | EMR
    | InRoomEvaluation
    | LearnerExam
    | ManualScenario
    | Monitor
    | PatientExam
    | PdlLive
    | PdlPostSession
    | PdlPreSession
    | Reflection
    | ScoringRubric
    | StandaloneAdminEval;

// Constants
export const AFTER_SESSION: EvaluationTime = 'AfterSession' as const;
export const AFTER_SESSION_EMR: EvaluationTime = 'AfterSessionEMR' as const;
export const BEFORE_SESSION: EvaluationTime = 'BeforeSession' as const;
export const BEFORE_SESSION_EMR: EvaluationTime = 'BeforeSessionEMR' as const;
export const DURING_SESSION: EvaluationTime = 'DuringSession' as const;
export const EMR: EvaluationTime = 'EMR' as const;
export const IN_ROOM_EVALUATION: EvaluationTime = 'InRoomEvaluation' as const;
export const LEARNER_EXAM: EvaluationTime = 'LearnerExam' as const;
export const MANUAL_SCENARIO: EvaluationTime = 'ManualScenario' as const;
export const MONITOR: EvaluationTime = 'Monitor' as const;
export const PATIENT_EXAM: EvaluationTime = 'PatientExam' as const;
export const PDL_LIVE: EvaluationTime = 'PdlLive' as const;
export const PDL_POST_SESSION: EvaluationTime = 'PdlPostSession' as const;
export const PDL_PRE_SESSION: EvaluationTime = 'PdlPreSession' as const;
export const REFLECTION: EvaluationTime = 'Reflection' as const;
export const SCORING_RUBRIC: EvaluationTime = 'ScoringRubric' as const;
export const STANDALONE_ADMIN_EVAL: EvaluationTime = 'StandaloneAdminEval' as const;

const LU_EvaluationTimes = {
    AFTER_SESSION,
    AFTER_SESSION_EMR,
    BEFORE_SESSION,
    BEFORE_SESSION_EMR,
    DURING_SESSION,
    EMR,
    IN_ROOM_EVALUATION,
    LEARNER_EXAM,
    MANUAL_SCENARIO,
    MONITOR,
    PATIENT_EXAM,
    PDL_LIVE,
    PDL_POST_SESSION,
    PDL_PRE_SESSION,
    REFLECTION,
    SCORING_RUBRIC,
    STANDALONE_ADMIN_EVAL,
} as const;

export default LU_EvaluationTimes;
